import '../Style/ParentsLove.css'
import girl from '../Images/girl.png'
import man from '../Images/man.png'
import boy from '../Images/boy.png'

function ParentsLove() {
    return (
        <>
            <div className="container-fluid ParentsLove row   pb-5 d-flex justify-content-center align-items-center m-0 ">
                    <div className=" text-center content-ParentsLove col-lg-10 p-4 mb-4">
                        <h1 className="display-2 fw-bold text-white">Why Parents Love Riley</h1>
                        <p className="fw-bold text-white">Join a community of parents like you who get it all done with Riley</p>
                    <div className='col-lg-2 btn-cu shadow m-auto text-center fw-bold p-3'>Join the Club</div>
                    


                <div className=' row gap-3 mt-5 '>
                        <div className='col-lg rate p-4 text-start'>
                            <h5 className='mb-5'>Riley feels like a personalized parent companion that will grow with my child. It offers tailored advice, activities, and resources that make navigating the challenges of parenthood so much easier.</h5>
                            <div>⭐️⭐️⭐️⭐️⭐️</div>
                            <div className='col d-flex mt-4'>
                                <div className='col-2 image-personal text-center me-2 p-1'>
                                <img src={girl} alt='' style={{width:"80%",height:"auto"}} />
                                </div>
                                <div className='col-8'>
                                    <h3>Holly W.</h3>
                                    <p>Mom of two (11m & 4y)</p>
                                </div>
                            </div>
                        </div>



                        <div className='col-lg col-sm rate p-4 text-start'>
                            <h5 className='mb-5'>Riley is such an amazing tool for managing our family life. From activity ideas, tracking feedings, and answers backed by data - Riley just plugs into my life as a parent. It’s like having a parenting assistant right at my fingertips!</h5>
                            <div>⭐️⭐️⭐️⭐️⭐️</div>
                            <div className='col d-flex mt-4'>
                                <div className='col-2 image-personal text-center me-2 p-1'>
                                <img src={man} alt='' style={{width:"80%",height:"auto"}} />
                                </div>
                                <div className='col-8'>
                                    <h3>Sebastian M.</h3>
                                    <p>Father of one (2y)</p>
                                </div>
                            </div>
                        </div>


                        <div className='col-lg rate p-4 text-start'>
                            <h5 className='mb-5'>Riley is like having a best friend with a PhD in child development who remembers what's important to me and helps me effectively parent my kiddo. I can't imagine parenting without it - and the personalized guidance is amazing.</h5>
                            <div>⭐️⭐️⭐️⭐️⭐️</div>
                            <div className='col d-flex mt-4'>
                                <div className='col-2 image-personal text-center me-2 p-1  '>
                                <img src={boy} alt='' style={{width:"80%",height:"auto"}} />
                                </div>
                                <div className='col-8'>
                                    <h3>Many K.</h3>
                                    <p>Father of one(11m & 4y)</p>
                                </div>
                            </div>
                        </div>
                </div>
                </div>




                </div>             
        </>
    )
}
export default ParentsLove;